(function () {
  const RUNTIME_KEY = 'PawlishFooterAccordionRuntime';
  const previousRuntime = window[RUNTIME_KEY];

  if (previousRuntime && typeof previousRuntime.destroy === 'function') {
    previousRuntime.destroy();
  }

  const roots = new Set();
  const instances = new WeakMap();
  const globalController = typeof AbortController === 'function' ? new AbortController() : null;
  const globalFallbackCleanup = [];

  function isEnabled(value) {
    return value === 'true';
  }

  function getControlledContent(footer, trigger) {
    const id = trigger.getAttribute('aria-controls');
    if (!id) return null;

    const content = document.getElementById(id);
    return content && footer.contains(content) ? content : null;
  }

  function createInstance(footer) {
    if (!footer || instances.has(footer)) return instances.get(footer) || null;
    if (!isEnabled(footer.dataset.proFooterAccordionEnabled)) return null;

    const closeOthers = isEnabled(footer.dataset.proFooterCloseOthers);
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const triggers = Array.prototype.slice.call(footer.querySelectorAll('[data-footer-accordion-trigger]'));
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const fallbackCleanup = [];

    function sync() {
      triggers.forEach(function (trigger) {
        const content = getControlledContent(footer, trigger);
        if (!content) return;

        if (mobileQuery.matches) {
          trigger.removeAttribute('tabindex');
          content.classList.toggle('is-open', trigger.getAttribute('aria-expanded') === 'true');
        } else {
          trigger.setAttribute('tabindex', '-1');
          content.classList.add('is-open');
        }
      });
    }

    function handleClick(event) {
      const target = event.target;
      const trigger = target && typeof target.closest === 'function'
        ? target.closest('[data-footer-accordion-trigger]')
        : null;

      if (!trigger || !footer.contains(trigger) || !mobileQuery.matches) return;

      const content = getControlledContent(footer, trigger);
      if (!content) return;

      const expanded = trigger.getAttribute('aria-expanded') === 'true';

      if (!expanded && closeOthers) {
        triggers.forEach(function (otherTrigger) {
          if (otherTrigger === trigger) return;

          otherTrigger.setAttribute('aria-expanded', 'false');
          const otherContent = getControlledContent(footer, otherTrigger);
          if (otherContent) otherContent.classList.remove('is-open');
        });
      }

      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      content.classList.toggle('is-open', !expanded);
    }

    if (controller) {
      footer.addEventListener('click', handleClick, { signal: controller.signal });
    } else {
      footer.addEventListener('click', handleClick);
      fallbackCleanup.push(function () {
        footer.removeEventListener('click', handleClick);
      });
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', sync);
      fallbackCleanup.push(function () {
        mobileQuery.removeEventListener('change', sync);
      });
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(sync);
      fallbackCleanup.push(function () {
        mobileQuery.removeListener(sync);
      });
    }

    function destroy() {
      if (controller) controller.abort();
      fallbackCleanup.splice(0).forEach(function (cleanup) {
        cleanup();
      });
      instances.delete(footer);
      roots.delete(footer);
    }

    const instance = { destroy: destroy, sync: sync };
    instances.set(footer, instance);
    roots.add(footer);
    sync();
    return instance;
  }

  function initWithin(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches('[data-pro-footer-accordion]')) {
      createInstance(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-pro-footer-accordion]').forEach(createInstance);
    }
  }

  function destroyWithin(scope) {
    if (!scope) return;

    Array.from(roots).forEach(function (footer) {
      if (footer === scope || (scope.contains && scope.contains(footer))) {
        const instance = instances.get(footer);
        if (instance) instance.destroy();
      }
    });
  }

  function handleSectionLoad(event) {
    initWithin(event.target);
  }

  function handleSectionUnload(event) {
    destroyWithin(event.target);
  }

  if (globalController) {
    document.addEventListener('shopify:section:load', handleSectionLoad, { signal: globalController.signal });
    document.addEventListener('shopify:section:unload', handleSectionUnload, { signal: globalController.signal });
  } else {
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    globalFallbackCleanup.push(function () {
      document.removeEventListener('shopify:section:load', handleSectionLoad);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    });
  }

  if (document.readyState === 'loading') {
    if (globalController) {
      document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, {
        once: true,
        signal: globalController.signal,
      });
    } else {
      const ready = function () { initWithin(document); };
      document.addEventListener('DOMContentLoaded', ready, { once: true });
      globalFallbackCleanup.push(function () {
        document.removeEventListener('DOMContentLoaded', ready);
      });
    }
  } else {
    initWithin(document);
  }

  window[RUNTIME_KEY] = {
    version: '1.0.0',
    init: function () { initWithin(document); },
    destroy: function () {
      if (globalController) globalController.abort();
      globalFallbackCleanup.splice(0).forEach(function (cleanup) {
        cleanup();
      });
      Array.from(roots).forEach(function (footer) {
        const instance = instances.get(footer);
        if (instance) instance.destroy();
      });
      roots.clear();
    },
  };
})();
